import { useCallback, useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';

const GITHUB_URL = 'https://github.com';
const SCOPES = { customScopes: { github: ['repo'] } };

/**
 * Whether the user has GitHub credentials with the `repo` scope, checked
 * without a popup, and a sign-in that asks for them. Shared by the home page
 * cards that search GitHub pull requests.
 */
export const useGitHubSignIn = () => {
  const scmAuth = useApi(scmAuthApiRef);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    let current = true;
    scmAuth
      .getCredentials({
        url: GITHUB_URL,
        additionalScope: SCOPES,
        optional: true,
      })
      .then(credentials => {
        if (current && credentials?.token) setSignedIn(true);
      })
      .catch(() => undefined);
    return () => {
      current = false;
    };
  }, [scmAuth]);

  const signIn = useCallback(async () => {
    const credentials = await scmAuth.getCredentials({
      url: `${GITHUB_URL}/`,
      additionalScope: SCOPES,
    });
    if (credentials.token) setSignedIn(true);
  }, [scmAuth]);

  return { signedIn, signIn };
};
